import { render, staticRenderFns } from "./PresentationComponent.vue?vue&type=template&id=1b3dcec2&scoped=true"
import script from "./PresentationComponent.vue?vue&type=script&lang=js"
export * from "./PresentationComponent.vue?vue&type=script&lang=js"
import style0 from "./PresentationComponent.vue?vue&type=style&index=0&id=1b3dcec2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3dcec2",
  null
  
)

export default component.exports